import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import { useHistory } from 'react-router-dom';
import ClickableDiv from 'components/Common/ClickableDiv';
import Styles from './index.module.css';

function NewAdCard() {
  const history = useHistory();
  return (
    <ClickableDiv
      className={Styles.container}
      onClick={() => history.push('/SelectOptionStep')}
    >
      <div>
        <AddIcon style={{ color: 'white' }} />
      </div>
      <div>
        新增廣告單元
      </div>
    </ClickableDiv>
  );
}

export default NewAdCard;
